
  import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import CrossIcon from '@/components/icons/Cross.vue'
import TickIcon from '@/components/icons/TickIcon.vue'
@Component({
  components: {
CrossIcon,
TickIcon
  }
})
export default class SwitchComponent extends  Vue {

    @Prop({type: String, required: false, default: '#1890ff'}) readonly onColor!: string;
    @Prop({type: String, required: false, default: '#BFBFBF'}) readonly offColor!: string;
    @Prop({type: String, required: false, default: '45px'}) readonly width!: string;
    @Prop({type: String, required: false, default: '22px'}) readonly height!: string;
    @Prop({type: Boolean, required: false, default: false})  isOn: boolean;
    @Prop({type: Boolean, required: false, default: false})  isround: boolean;
    @Prop({type: Boolean, required: false, default: true}) readonly isHandleInnerState!: boolean;
    @Prop({type: Boolean, required: false, default: true}) readonly showIcons!: boolean;
    @Prop({type: Function, required: false,}) readonly onToggle!: Function;

    isSwithActive = false;

    @Watch('isOn',{immediate: true})
    watchIsOn(){
      this.isSwithActive = this.isOn
    }


    async handleToggle(e)  {
        const toggleState = !this.isSwithActive
    if (this.isHandleInnerState) {
        this.isSwithActive = toggleState
    }
    await this.$emit('toggle', toggleState)
    await this.onToggle?.(toggleState)

    }

get ballStyles () {
  return  {'width': this.isround ? `calc(${this.height} - 5px)` : this.height, 'height': `calc(${this.height} - 5px)`,
  'border-radius': this.isround ? `100%`: '16px' }

}

}

